import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import './DailyNav.css';
import Slider from 'react-slick';
// import marketup from '../../Images/arrow-up.png';
// import marketdown from '../../../Images/Images/arrow-down.png';
import { useNavigate } from "react-router-dom";
import Pagination from '../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'



function DailyNav() {
    const { BaseURL } = useContext(URLstateContext);
    const [DataHolding, setDataHolding] = useState([]);
    const [DataMfHoldingdrop, setDataMfHoldingdrop] = useState([]);
    const [DataMfHoldingdropcat, setDataMfHoldingdropcat] = useState([]);
    const [Category, setCategory] = useState('5946');
    const [Sheme, setSheme] = useState('26');
    const [ShemeCode, setShemeCode] = useState('10645');
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [valuecategory, setValuecategory] = useState([]);
    const [valuecategory1, setValuecategory1] = useState([]);
    const [valuecategory2, setValuecategory2] = useState([]);
    const [DataMfHoldingdropSheme, setDataMfHoldingdropSheme] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);

    let getDataHolding, getDataHoldingdrop,
        getDataHoldingdropcat, getDataHoldingdropSheme;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";

        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdrop) => {
                getDataHoldingdrop = dataMHoldingdrop.data;
                setDataMfHoldingdrop(getDataHoldingdrop);
                var codename = getDataHoldingdrop[0].co_name;
                setValuecategory(codename)
                setloadingshow(false);

            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropcat) => {
                getDataHoldingdropcat = dataMHoldingdropcat.data;
                setDataMfHoldingdropcat(getDataHoldingdropcat);
                var codename = getDataHoldingdropcat[0].VCLASS;
                setValuecategory1(codename)
                setloadingshow(false);

            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropSheme) => {
                getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                var codename = getDataHoldingdropSheme[0].SCH_NAME;
                setValuecategory2(codename)
                setloadingshow(false);

            })
            .catch((error) => {
            });

        const getUrlMfTopHolding = BaseURL + "MFNavDaily";

        fetch(`${getUrlMfTopHolding}/${Category}/${Sheme}/${ShemeCode}/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHolding = dataMHolding.data;
                setDataHolding(getDataHolding);
                setloadingshow(false);
                // console.log(getDataHolding, "MfTopHolding")
            })
            .catch((error) => {
            });
    }, [Category, Sheme, ShemeCode]);


    const currentTableData = useMemo(() => {
        if (DataHolding != null && DataHolding != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataHolding != null && DataHolding != []) {
                if (DataHolding.length > 0) {
                    return DataHolding.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataHolding]);

    const routeChange = (paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Daily NAV</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Daily-loser-sc'>

                            <div className='Daily-header'>

                                <h2><span>Daily NAV</span></h2>


                            </div>
                            <MarketMF optionValue="Daily NAV" />
                            <div className='Daily-right'>
                                <div className='ttDaily-inner-select'>

                                    <select onChange={(event) => setCategory(event.target.value)}>
                                        <option>Select Fund House</option>
                                        {DataMfHoldingdrop && DataMfHoldingdrop.map(
                                            ({ mf_cocode, co_name }) => (

                                                <option value={mf_cocode} selected={valuecategory === co_name}>{co_name}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='Daily-inner-select'>
                                    <select onChange={(event) => setSheme(event.target.value)}>
                                        <option>Select Category</option>
                                        {DataMfHoldingdropcat && DataMfHoldingdropcat.map(
                                            ({ VCLASSCODE, VCLASS }) => (

                                                <option value={VCLASSCODE} selected={valuecategory1 === VCLASS}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='Daily-inner-select'>
                                    <select onChange={(event) => setShemeCode(event.target.value)}>
                                        <option>Select Scheme</option>
                                        {DataMfHoldingdropSheme && DataMfHoldingdropSheme.map(
                                            ({ MF_SCHCODE, SCH_NAME }) => (

                                                <option value={MF_SCHCODE} selected={valuecategory2 === SCH_NAME}>{SCH_NAME}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='Daily-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Scheme Name</th>
                                            <th className='text-right'>NAV Date</th>
                                            <th className='text-right'>NAV (Rs)</th>
                                            <th className='text-right'>Repurchase Price (Rs)</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ sch_name, navdate, navrs, RepurchasePrice }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={() => routeChange(sch_name)}>{sch_name}</h6></td>


                                                    <td className="text-right"> {(navdate != null) ? navdate.split(" ").join("-") : ''}</td>
                                                    <td className="text-right"> {(navrs != null) ? navrs.toFixed(2) : 0}</td>
                                                    <td className="text-right">{RepurchasePrice}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>

                            {(DataHolding != null && DataHolding != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(DataHolding.length != null) ? DataHolding.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default DailyNav